import React from 'react'
import ReactPaginate from 'react-paginate'

export default function Pagination (props) {

  const handlePageClick = (e) => {
    props.setPage(e.selected + 1)
  }

  if (props.totalPages <= 1) return null

  return (
    <ReactPaginate
      className={'dm-pagination ' + props.containerClass}
      pageClassName="dm-pagination__link"
      previousClassName="dm-pagination__link dm-pagination__link--previous"
      nextClassName="dm-pagination__link dm-pagination__link--next"
      activeClassName="dm-pagination__link--active"
      disabledClassName="dm-pagination__link--disabled"
      breakClassName="dm-pagination__link"
      breakLabel="..."
      pageRangeDisplayed={3}
      marginPagesDisplayed={3}
      pageCount={props.totalPages}
      previousLabel="<"
      nextLabel=">"
      onPageChange={(e) => handlePageClick(e)}
      forcePage={props.activePage - 1}
    />
  )
}